import { render } from "./paperContainer.vue?vue&type=template&id=387f37c0&scoped=true"
const script = {}

import "./paperContainer.vue?vue&type=style&index=0&id=387f37c0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387f37c0"]])

export default __exports__